var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-buttons"},[_c('button',[_c('svg-icon',{attrs:{"name":"google"}}),_vm._v(" Продолжить с Google")],1),_c('button',[_c('svg-icon',{attrs:{"name":"facebook"}}),_vm._v(" Продолжить с Facebook")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }